module.exports = __webpack_public_path__ + "img/2004_S.b7907b96.png";